import { useModal } from '@gorila-shared-ui/components';
import { ParagraphMedium } from 'baseui/typography';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { FEEDBACK, FEEDBACK_PREFIXES } from '../../../constants/app';
import { useFeedback } from '../../../hooks/useFeedback';
import { cancelFleetService } from '../../../services/fleetService';
import { apiParamsState } from '../../../storage/app';
import { FleetService } from '../../../types/fleet';
import ConfirmModal from '../../shared/ConfirmModal';

export function useFleetDeleteService(onSucceed?: () => void) {
  const apiParams = useRecoilValue(apiParamsState);
  const { showFailFeedback, showDeletionFeedback } = useFeedback();
  const [selectedService, setSelectedService] = useState<FleetService>();
  const { openModal: openDeleteModal, showModal: showDeleteModal, closeModal: closeDeleteModal } = useModal();

  const onOpenDeleteModal = (service: FleetService) => {
    setSelectedService(service);
    openDeleteModal();
  };

  const onCloseDeleteModal = () => {
    closeDeleteModal();
    setSelectedService(undefined);
  };

  const onDelete = async () => {
    if (!selectedService || !apiParams) return;
    const response = await cancelFleetService({
      serviceId: selectedService._id,
      clientId: apiParams.clientId,
      subClientId: apiParams.subClientId,
    });
    if (!response?.error) {
      showDeletionFeedback(FEEDBACK.canceled(FEEDBACK_PREFIXES.fleetService, selectedService._id));
      onCloseDeleteModal();
      onSucceed?.();
    } else {
      showFailFeedback(
        response?.error || FEEDBACK.failedCancellation(FEEDBACK_PREFIXES.fleetService, selectedService._id),
      );
    }
  };

  const deleteServiceDisplay = selectedService ? (
    <ConfirmModal
      isOpen={showDeleteModal}
      onCancel={onCloseDeleteModal}
      onConfirm={onDelete}
      cancelText="No, regresar"
      confirmText="Sí, cancelar"
      description={<ParagraphMedium>¿Desea cancelar este servicio?</ParagraphMedium>}
    />
  ) : null;

  return {
    onOpenDeleteModal,
    deleteServiceDisplay,
  };
}
